export default "__VITE_ASSET__DjVhx1m5__"